import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import { Api } from "../../../services/api";
// import { Api } from "../../../services/api";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
const INTERIOR_DESIGN_DASHBOARD = () => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const [activeIndex, setActiveIndex] = useState(0);
    const [globalFilter, setGlobalFilter] = useState('');
    const [projects, setProjects] = useState([]);
    const [searchprojects, setSearchprojectsProjects] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [projectsArchive, setProjectsArchive] = useState([]);
    const [searchprojectsArchive, setSearchprojectsArchive] = useState([]);
    const [archiveGlobalFilter, setArchiveGlobalFilter] = useState('');

    const [projectsWarranty, setProjectsWarranty] = useState([]);
    const [searchprojectsWarranty, setSearchprojectsWarranty] = useState([]);
    const [warrantyGlobalFilter, setWarrantyGlobalFilter] = useState('');

    const [visible, setVisible] = useState(false);
    const [archiveId, setArchiveId] = useState('');
    const [archiveList, setArchiveList] = useState('');



    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    onChange={(e) => searchproject(e.target.value)}
                    placeholder="Search..."
                />
            </span>
        </div>
    );

    useEffect(() => {
        getProjectDetails();
        return () => {
          // Cleanup tasks before the component is unmounted
        };
      }, []);
      const getProjectDetails = () => {
        // fetch.
        var user_id = localStorage.getItem('user_id');
    var  role_id = localStorage.getItem('role_id');
    var _body = {
      userId: user_id,
      role_id: role_id,
    }
        fetch(Api.API_BASE_URL + 'interior-template/get', {
          method: "POST",
    
          body: JSON.stringify(_body),
        })
          .then((response) => response.json())
          .then((response) => {
            // setIsLoading(false);
            setArchiveList(response.archive);
            setProjects(response.result);
            setSearchprojectsProjects(response.result);
    
          })
          .catch((error) => {
            // setIsLoading(false);
            console.error("Error:", error);
          });
      }

      const archiveComplateion = () => {
        // fetch.
      
       
      }
    const searchproject = (searchValue) => {

        setProjects([]);
        const searchResult = searchprojects.filter((item) =>
            item.projectName.toLowerCase().includes(searchValue.toLowerCase())
        );

        setProjects(searchResult);
        console.log(searchResult)
    }


    const accept = () => {
        archiveComplateion();
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
    const handleArchiveProject = (id) => { 
        console.log("Archive id",id)
        setArchiveId(id);
        (confirmDialog({
            className: 'flex m-4',
            message: (
                <div className="flex flex-column m-4">
                   
                    <span>Do you want to delete this record?</span>
                </div>
            ),
            header:(
                <div className="flex flex-column m-2">
                   
                    <span>Delete Confirmation</span>
                </div>
            ),
            // header: 'Delete Confirmation',
            //icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger m-2 p-2',
            rejectClassName: 'm-2  p-2',
            accept,
            reject
        }))
       
        // archiveComplateion();
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                {/* <Button icon="pi pi-copy" rounded outlined className="mr-2" /> */}
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => edit(rowData.id)}/>
                <Button icon="pi pi-cloud-download" rounded outlined severity="danger" onClick={()=>handleArchiveProject(rowData.id)} />
            </React.Fragment>
        );
    };

    const archiveheader = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <div></div>
            <span className="p-input-icon-left ">
                <InputText className="input-field" type="search" onChange={(e) => searchprojectsArchivee(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    const warrantyheader = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <div></div>
            <span className="p-input-icon-left ">
                <InputText className="input-field" type="search" onChange={(e) => searchprojectsWarrantyy(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    const searchprojectsArchivee = (searchValue) => {

        setProjectsArchive([]);
        const searchResult = searchprojectsArchive.filter((item) =>
            item.projectName.toLowerCase().includes(searchValue.toLowerCase())
        );

        setProjectsArchive(searchResult);
        console.log(searchResult)
    }

    const searchprojectsWarrantyy = (searchValue) => {

        setProjectsArchive([]);
        const searchResult = searchprojectsWarranty.filter((item) =>
            item.projectName.toLowerCase().includes(searchValue.toLowerCase())
        );

        setProjectsArchive(searchResult);
        console.log(searchResult)
    }

    const openModal = () => {
        setVisible(true);
    }

    const addPro = () => {
        navigate('/add-interior-design-template')
    }
    const edit = (id) => {
        navigate('/edit-interior-design-template/'+id)
    }


    return (
        <><Toast ref={toast} />
        <ConfirmDialog />
            <div className="one-line-container">
                <div>PROJECTS</div>

                <button type="button" className="custom-button" onClick={addPro} >
                    + ADD
                </button>
            </div>

            <div className="pagee-container">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Active" className="p-2 pb-2" >
                        <div className=" m-0" style={{ width: "100%" }} >
                            <DataTable value={projects} paginator rows={10} dataKey="id" selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)} selectionMode="single" header={header} globalFilter={globalFilter} >
                                <Column field="project_name" header="Project Name" ></Column>
                                <Column field="ProjectType" header="Project Type" ></Column>
                               <Column field="pM" header="Project Manager" body={(e)=><span>{e.first_name} {e.last_name}</span>}></Column>
                                <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ minWidth: '12rem', textAlign: 'center', padding: '4px' }}></Column>
                            </DataTable>
                        </div>
                    </TabPanel>
                    <TabPanel header="Archive" className="p-2">
                        <div className=" m-0" style={{ width: "100%" }} >
                        <DataTable value={archiveList} paginator rows={10} dataKey="id" selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)} selectionMode="single" header={header} globalFilter={globalFilter} >
                                <Column field="project_name" header="Project Name" ></Column>
                                <Column field="ProjectType" header="Project Type" ></Column>
                               <Column field="pM" header="Project Manager" body={(e)=><span>{e.first_name} {e.last_name}</span>}></Column>
                                <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ minWidth: '12rem', textAlign: 'center', padding: '4px' }}></Column>
                            </DataTable>
                        </div>
                    </TabPanel>

                    <TabPanel header="Warranty" className="p-2">
                        <div className=" m-0" style={{ width: "100%" }} >
                            <DataTable value={projectsWarranty} paginator rows={10} dataKey="id" selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)} selectionMode="single" header={warrantyheader} globalFilter={warrantyGlobalFilter}  >
                                <Column field="projectName" header="Project Name" ></Column>
                                <Column field="projectType" header="Project Type" ></Column>
                                <Column field="esitmatedSales" header="Estimated Sales" style={{ textAlign: 'center' }}></Column>
                                {/* <Column field="esitmatedSales" header="Actual Start date" style={{ textAlign: 'center' }}></Column>
                                <Column field="esitmatedSales" header="Actual End date" style={{ textAlign: 'center' }} ></Column> */}
                                <Column field="pM" header="Project Manager"></Column>
                                <Column body={actionBodyTemplate} header="Action" exportable={false} style={{ minWidth: '12rem', textAlign: 'center' }}></Column>
                            </DataTable>
                        </div>
                    </TabPanel>

                </TabView>
            </div>

            <Dialog header="Header" visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)} >
                <p className="m-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                    Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
            </Dialog>
        </>
    )
}

export default INTERIOR_DESIGN_DASHBOARD;